var map = {
	"./animations.scss": "bc44",
	"./colors.scss": "62d7",
	"./desktop.css": "ebf2",
	"./edgeryders_group.jpg": "1502",
	"./img/press/dazed.png": "e532",
	"./img/press/di.png": "8f5d",
	"./img/press/guardian.jpg": "cb37",
	"./img/press/huffpost.jpg": "a2d1",
	"./img/press/ilsole24ore.png": "703e",
	"./img/press/krautreporter.png": "9c2e",
	"./img/press/mutinerie.png": "da96",
	"./img/press/nation.png": "e536",
	"./img/press/nesta.png": "ceff",
	"./img/press/newyorker.jpg": "ec78",
	"./img/press/opengov.png": "4a73",
	"./img/press/republica.png": "4bd5",
	"./img/press/wired.png": "6a6f",
	"./index.scss": "139c",
	"./main.css": "845f",
	"./mixins.scss": "ebdc",
	"./typography.scss": "db8c",
	"./undraw_add_document_0hek.svg": "8912",
	"./undraw_newspaper_k72w.svg": "30ac",
	"./undraw_real_time_collaboration_c62i.svg": "8be8",
	"./undraw_remotely_2j6y-3.svg": "1c3a",
	"./undraw_web_developer_p3e5.svg": "c3bd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";